import { sendRequest } from "./service";

export default sendRequest;
